import { Modal } from "react-bootstrap";
import { useFetchData, usePostApiRequest } from "../../../helpers/api";
import { CustomSelect } from "../../../components/CustomSelect";
import LoadingSpinner from "../../../components/loading/LoadingSpinner";
import { useState } from "react";
import toast from "react-hot-toast";

const shapeOptions = [{ value: "ROUND", label: "ROUND" }];

const AddModal = ({ show, onHide, formData, setFormData, defaultFormData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { data: diamondSizeData } = useFetchData(
    "diamondSizeFilterModal",
    "/Customer/GetDiamondSize",
    { Shape: "ROUND" }
  );
  const postApiRequest = usePostApiRequest();

  const onCloseModal = () => {
    onHide();
  };

  const handleChange = (field, value) => {
    setFormData((prevData) => {
      let updatedData = { ...prevData, [field]: value };

      const selectedSizeOption = diamondSizeData?.Data?.find(
        (option) => option.Pointer === parseFloat(updatedData.Size)
      );

      const pointerValue = selectedSizeOption?.Pointer || 0;
      const sizeCodeValue = selectedSizeOption?.SizeCode || "";

      if (field === "Size") {
        updatedData.SizeCode = sizeCodeValue;

        if (
          updatedData.NumberOfPCS &&
          !isNaN(parseFloat(updatedData.NumberOfPCS)) &&
          pointerValue
        ) {
          updatedData.CaratWeight = (
            parseFloat(updatedData.NumberOfPCS) * pointerValue
          ).toFixed(4);
        } else {
          updatedData.CaratWeight = "";
        }
      }

      if (field === "NumberOfPCS") {
        if (value === "" || isNaN(parseFloat(value))) {
          updatedData.CaratWeight = "";
        } else if (pointerValue) {
          updatedData.CaratWeight = (parseFloat(value) * pointerValue).toFixed(
            4
          );
        }
      }

      if (field === "CaratWeight") {
        if (value === "" || isNaN(parseFloat(value))) {
          updatedData.NumberOfPCS = "";
        } else if (pointerValue) {
          updatedData.NumberOfPCS = Math.round(
            parseFloat(value) / pointerValue
          );
        }
      }

      return updatedData;
    });
  };

  const saveReset = () => {
    setFormData(defaultFormData);
    onHide();
  };

  const saveStock = async () => {
    setIsLoading(true);
    const data = [formData];

    try {
      const response = await postApiRequest({
        url: "/Customer/SaveCustomerStock",
        method: "POST",
        data: data,
        queryKey: ["customerStock"],
      });
      if (response.Status === true) {
        saveReset();
        toast.success(response.Message);
      } else {
        toast.error(response.Message);
      }
    } catch (error) {
      console.error("API call failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const mapOptions = (data, valueKey, labelKey) =>
    data?.map((option) => ({
      value: String(option[valueKey]),
      label: option[labelKey],
    }));

  return (
    <Modal
      show={show}
      onHide={onCloseModal}
      className="add_stock_modal"
      backdrop="static"
      keyboard={false}
    >
      {isLoading && <LoadingSpinner />}
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={{ fontSize: "15px" }}
        >
          Add My Stock
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="input_con">
          <CustomSelect
            options={shapeOptions}
            value={formData.Shape}
            onChange={(value) => handleChange("Shape", value)}
            placeholder="Select Shape"
            showLabel={true}
            labelName="Select Shape"
          />
        </div>
        <div className="input_con">
          <CustomSelect
            options={mapOptions(diamondSizeData?.Data, "Pointer", "SizeCode")}
            value={formData.Size ? String(formData.Size) : ""}
            onChange={(value) => handleChange("Size", value)}
            placeholder="Select Size"
            showLabel={true}
            labelName="Select Size"
            customClass="size_custom_filter"
          />
        </div>
        <div className="input_con">
          <label htmlFor={`custom_filter_pcs`}>Number of PCS.</label>
          <input
            type="text"
            value={formData.NumberOfPCS}
            id="custom_filter_pcs"
            name="custom_filter_pcs"
            onChange={(e) => handleChange("NumberOfPCS", e.target.value)}
          />
        </div>

        {/* Weight Input */}
        <div className="input_con">
          <label htmlFor={`custom_filter_carat`}>Carat Weight</label>
          <input
            type="text"
            value={formData.CaratWeight}
            id="custom_filter_carat"
            name="custom_filter_carat"
            onChange={(e) => handleChange("CaratWeight", e.target.value)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="close_btn" type="button" onClick={onCloseModal}>
          Cancel
        </button>
        <button className="submit_btn" type="button" onClick={saveStock}>
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddModal;
